import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography';
import { Paper, Divider, Fab, Grid } from '@material-ui/core';
import TrainerList from '../DashComponents/TrainerComponents/TrainerList'
import AddIcon from '@material-ui/icons/Add';
import Modal from '@material-ui/core/Modal';
import AddTrainerForm from '../DashComponents/TrainerComponents/AddTrainerForm'
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';


  
  function getModalStyle() {
    const top = 50 ;
    const left = 50 ;
  
    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }
  
  const styles = theme => ({
    paper: {
      position: 'absolute',
      //width: theme.spacing.unit * 50,
      width: '100%',
      maxWidth: '800px',
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing.unit * 4,
      outline: 'none',
    },
    close: {
    padding: theme.spacing.unit / 2,
  },
  delete: {
    backgroundColor: theme.palette.error.dark,
  },
  });



class Trainers extends Component {
     state = {
        open: false,
        openSnackbar: false,
    };
    handleOpen = () => {
        this.setState({ open: true });
    };
    
    handleClose = () => {
        this.setState({ open: false });
    };
    handleOpenSnackbar = () => {
      this.setState({ openSnackbar: true });
    };

    handleCloseSnackbar = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }

      this.setState({ openSnackbar: false });
    };
    render() {
        const { classes } = this.props;
        //console.log('TRAniers', this.props)
        var companyId = sessionStorage.getItem('companyId')
        var buttonBg = sessionStorage.getItem('buttonBgColor')
        var buttonColor = sessionStorage.getItem('buttonColor') 
        return (
            <div className="slideUp">

                <Typography component="h1" variant="h5">
                Trainers
                </Typography>
                <Paper style={{padding: '24px', marginTop: '24px' }}>

                <Grid
                  justify="space-between" // Add it here :)
                  container 
                  style={{marginBottom: '24px'}}
                  spacing={24}
                >
                    <Grid item>

                    </Grid>
                    <Grid item>
                           <Fab onClick={this.handleOpen} variant="extended"  aria-label="Add" style={{background: buttonBg, color: buttonColor }} >
                               <AddIcon />
                                Add Trainer
                            </Fab>
                       </Grid>
                </Grid>

                        <Divider style={{marginBottom: '24px'}}/>
                        <TrainerList handleOpenSnackbar={this.handleOpenSnackbar} companyId={companyId} />

                </Paper>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.open}
                    onClose={this.handleClose}
                    >
                    <div style={getModalStyle()} className={classes.paper}>
                        <Typography variant="h6" id="modal-title">
                        New Trainer Informations
                        </Typography>
                        <Typography variant="subtitle1" id="simple-modal-description">
                        Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
                        </Typography>

                        <AddTrainerForm buttonBg={buttonBg} buttonColor={buttonColor} companyId={companyId}/>
                    </div> 
                </Modal>
                <Snackbar         
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  open={this.state.openSnackbar}
                  autoHideDuration={6000}
                  onClose={this.handleCloseSnackbar}
                  ContentProps={{
                    classes: {
                        root: classes.delete
                    }
                  }}
                  message={<span id="message-id"> Trainer is deleted !</span>}
                  action={[
                  
                    <IconButton
                      key="close"
                      aria-label="Close"
                      color="inherit"
                      className={classes.close}
                      onClick={this.handleCloseSnackbar}
                    >
                      <CloseIcon />
                    </IconButton>,
                  ]}
                />
            </div>
        )
    }
}
Trainers.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(Trainers);